import { DateTime } from 'luxon';

export const voteDates = [
  '2024-07-31',
  '2024-08-01',
  '2024-08-02',
  '2024-08-03',
  '2024-08-04',
  '2024-08-05',
  '2024-08-06',
];

export const isContestApplyTerm = () => {
  const now = DateTime.local({ zone: 'Asia/Seoul' });
  const endAt = DateTime.fromObject(
    {
      year: 2024,
      month: 7,
      day: 25,
      hour: 0,
      minute: 0,
    },
    { zone: 'Asia/Seoul' },
  );

  return now <= endAt;
};

export const isContestVoteTerm = () => {
  const now = DateTime.local({ zone: 'Asia/Seoul' });
  const startAt = DateTime.fromObject(
    {
      year: 2024,
      month: 7,
      day: 31,
      hour: 0,
      minute: 0,
    },
    { zone: 'Asia/Seoul' },
  );
  const endAt = DateTime.fromObject(
    {
      year: 2024,
      month: 8,
      day: 6,
      hour: 23,
      minute: 59,
    },
    { zone: 'Asia/Seoul' },
  );

  return now >= startAt && now <= endAt;
};

export const isContestReviewTerm = () => {
  const now = DateTime.local({ zone: 'Asia/Seoul' });
  const startAt = DateTime.fromObject(
    {
      year: 2024,
      month: 8,
      day: 6,
      hour: 23,
      minute: 59,
    },
    { zone: 'Asia/Seoul' },
  );
  return now >= startAt;
};

export const isContestWriteTerm = () => {
  const now = DateTime.local({ zone: 'Asia/Seoul' });
  const startAt = DateTime.fromObject(
    {
      year: 2024,
      month: 8,
      day: 20,
      hour: 18,
      minute: 0,
    },
    { zone: 'Asia/Seoul' },
  );
  return now >= startAt;
};

// 픽앤츄 2026
export const CONTEST_APPLY_EPISODE_COUNT = 7;
